import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat, numericFormatter } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  RSelect,
  Row,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { buildProcessingInventoryKey, CURRENCY_CODE, SUMARY_STATEMENT_TYPE, SUMMARY_STATEMENT_TAX_DETAIL_KEY } from "../../utils/Utils";

const SUMARY_STATEMENT_TYPE_OPTIONS = Object.keys(SUMARY_STATEMENT_TYPE).map((c) => ({
  label: SUMARY_STATEMENT_TYPE[c],
  value: c,
}));

const TAX_DETAIL_KEY_OPTIONS = Object.keys(SUMMARY_STATEMENT_TAX_DETAIL_KEY).map((c) => ({
  label: SUMMARY_STATEMENT_TAX_DETAIL_KEY[c],
  value: c,
}));




const DEFAULT_SUMMARY = {
  id: null,
  type: "",
  key: "",
  value: '',
  warehouseId: null,
};

const SumaryStatementManager = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [data, setData] = useState([]);
  const [editId, setEditedId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [deleteId, setDeleteId] = useState();
  const [mortgageContracts, setMortgageContracts] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [ingredientOptions, setIngredientOptions] = useState([]);
  const [bankAccountOptions, setBankAccountOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [materialOptions, setMaterialOptions] = useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
  });
  const [filter, setFilter] = useState({
    type: searchParams.get("type") || 'CUSTOMER',
  });

  useEffect(() => {
    GET("customer", {}, true).then((resp) => {
      setCustomerOptions(
        resp.data?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
    GET(`/transaction-history/mortgage-contract`, {}, true)
      .then(({ data }) => {
        setMortgageContracts(data.map((c) => ({
          label: `${c.contractId} - ${c.bankName}- ${numericFormatter(`${c.firstDebt || 0}`, {
            thousandsGroupStyle: "thousand",
            thousandSeparator: ",",
            decimalScale: c.currency === 'VND' ? 2 : 4,
            suffix: c.currency === 'VND' ? 'đ' : '',
            prefix: c.currency === 'USD' ? '$' : '',
          })}`,
          value: c.contractId,
          data: c,
        })));
      })

    GET("/bank-account", {}, true).then(({ data }) => {
      setBankAccountOptions([
        ...data?.map((c) => ({
          label: `${c.name}`,
          value: c.id,
          data: c,
        })),
      ]);
    });

    GET("ingredient", {}, true).then(({ data }) => {
      if (data && data.rows && data.rows.length) {
        setIngredientOptions(
          data.rows.map((c) => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        );
      }
    });
    GET("material", {}, true).then(({ data }) => {
      setMaterialOptions(data.map((c) => ({
        label: `${c.name}(${c.unit})`,
        value: `${c.id}`,
        data: c,
      })));
    });
  }, []);

  const generateName = (item) => {
    switch (item.type) {
      case 'BANK_ACCOUNT':
      case 'BANK_ACCOUNT_USD':
        return bankAccountOptions.find(e => +e.data.id === +item.key)?.data?.name || item.key
      case 'CUSTOMER':
        return customerOptions.find(e => e.data.id === item.key)?.data?.name || item.key
      case 'INGREDIENT_LAST_WEIGHT':
        return ingredientOptions.find(e => +e.data.id === +item.key)?.data?.name || item.key
      case 'MORTGAGE_CONTRACT':
        return item.key;
      case 'LAST_AMOUNT':
        return SUMARY_STATEMENT_TYPE.LAST_AMOUNT;
      case 'TAX':
        return SUMMARY_STATEMENT_TAX_DETAIL_KEY[item.key] || item.key
      case 'INVENTORY_MATERIAL':
        return materialOptions.find(e => +e.data.id === +item.key)?.data?.name || item.key
      case 'INVENTORY_QUOTATION_VALUE':
        return `Giá trị kho cuối kì`;
      case 'PROCESSING_INVENTORY': {
        // key = `${customerId}|DTP`
        const [customerId, ingredientId] = `${item.key || ''}`.split('|');
        const customerName = customerOptions.find(e => e.data.id === customerId)?.data?.name || customerId;
        const ingredientName = ingredientOptions.find(e => e.data.id === ingredientId)?.data?.name || ingredientId;
        return `${customerName} - ${ingredientName}`;
      }
      default:
        return item.key
    }
  }


  const {
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: DEFAULT_SUMMARY,
  });
  const type = watch('type')

  const showName = useMemo(() => {
    return ['BANK_ACCOUNT', 'BANK_ACCOUNT_USD', 'CUSTOMER', 'INGREDIENT_LAST_WEIGHT', 'MORTGAGE_CONTRACT', 'TAX', 'INVENTORY_MATERIAL', 'PROCESSING_INVENTORY'].includes(type)
  }, [type])

  // Đầu kỳ kho gia công: chọn KH có tick "nhận gia công"
  const processingCustomerOptions = useMemo(() => {
    return customerOptions.filter((c) => !!c.data?.isProcessingCustomer)
  }, [customerOptions])
  const colTable = [
    {
      Header: "loại",
      accessor: (item) => SUMARY_STATEMENT_TYPE[item.type],
    },

    ...(['INGREDIENT_LAST_WEIGHT', 'INVENTORY_MATERIAL'].includes(filter.type) ? [{
      Header: "Kho",
      accessor: (item) => item?.warehouse?.name || '',
    }] : []),
    {
      Header: "Tên",
      accessor: (item) => generateName(item),
    },
    {
      Header: "Giá trị",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          value={item.value}
          displayType={"text"}
          decimalScale={2}
          thousandSeparator={","}
          thousandsGroupStyle="thousand"
        />
      ),
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Cập nhật</span>
                    </DropdownItem>
                  </li>

                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    const newParams = new URLSearchParams({
      type: filter.type,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    setLoading(true);
    setData([]);
    let params = {
      type: filter.type,

    };

    GET(`/sumary-statement/get-first-summary-statement`, params, true)
      .then(({ data }) => {
        setData(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [filter, timeNow]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
    setEditedId();
    setDeleteId();
    reset({
      ...DEFAULT_SUMMARY
    })
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
  };

  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`/sumary-statement/get-first-summary-statement/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const formData = getValues();
    formData.exchangeRate = formData.exchangeRate || null;
    formData.amountUSD = formData.amountUSD || null;
    if (!['INGREDIENT_LAST_WEIGHT', 'INVENTORY_MATERIAL'].includes(formData.type)) {
      formData.warehouseId = null;
    }
    const request = editId
      ? PUT(
        `/sumary-statement/get-first-summary-statement/${editId}`,
        formData,
        {},
        true
      )
      : POST("/sumary-statement/get-first-summary-statement", formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
        setTimeNow(moment().valueOf());
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onDelete = (id) => {
    if (!id) {
      return;
    }
    DELETE(`/sumary-statement/get-first-summary-statement/${id}`, {}, true)
      .then(() => {
        toast.success("Xóa thành công");
        resetData();
        setTimeNow(moment().valueOf());
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Quản lý đầu kỳ"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đầu kỳ</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          placeholder="Chọn Loại"
                          classNamePrefix="form-control"
                          options={SUMARY_STATEMENT_TYPE_OPTIONS}
                          value={SUMARY_STATEMENT_TYPE_OPTIONS.find(
                            (c) => c.value === filter.type
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              type: val?.value || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    {['INGREDIENT_LAST_WEIGHT', 'INVENTORY_MATERIAL'].includes(filter.type) ? <li>
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <RSelect
                            isClearable
                            placeholder={"Lọc theo kho"}
                            options={warehouseOptions}
                            value={warehouseOptions.find((c) => c.value === filter.warehouseId) || null}
                            onChange={(val) => {
                              setFilter({
                                ...filter,
                                warehouseId: val?.value || undefined,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </li> : <></>}

                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm đầu kỳ</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Thêm đầu kỳ</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Loại
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="type"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={SUMARY_STATEMENT_TYPE_OPTIONS}
                                value={SUMARY_STATEMENT_TYPE_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => {
                                  onChange(val?.value)
                                  if (['LAST_AMOUNT', 'INVENTORY_QUOTATION_VALUE'].includes(val?.value)) {
                                    setValue('key', 'AMOUNT')
                                  } else if (val?.value === 'TAX') {
                                    setValue('key', 'SUMMARY')
                                  }
                                  else if (['INGREDIENT_LAST_WEIGHT', 'INVENTORY_MATERIAL'].includes(val?.value)) {
                                    setValue('warehouseId', null)
                                  }

                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="type"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    {['INGREDIENT_LAST_WEIGHT', 'INVENTORY_MATERIAL'].includes(type) ? <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Kho
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="warehouseId"
                            rules={{ required: "Vui lòng nhập thông tin" }}

                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                isClearable
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={warehouseOptions}
                                value={warehouseOptions.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => {
                                  onChange(val?.value);
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="warehouseId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col> : <></>}

                    <Col md="12" className={showName ? '' : 'd-none'}>
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Tên
                          <span className="text-danger">*</span>
                        </label>

                        <div className="form-control-wrap">
                          {
                            type === 'BANK_ACCOUNT' ?
                              <Controller
                                control={control}
                                name="key"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, name, ref }) => (
                                  <ReactSelect
                                    classNamePrefix="form-control"
                                    inputRef={ref}
                                    name={name}
                                    options={bankAccountOptions}
                                    value={bankAccountOptions.find(
                                      (c) => +c.value === +value
                                    ) || null}
                                    onChange={(val) => onChange(val.value)}
                                  />
                                )}
                              /> : type === 'BANK_ACCOUNT_USD' ?
                                <Controller
                                  control={control}
                                  name="key"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, name, ref }) => (
                                    <ReactSelect
                                      classNamePrefix="form-control"
                                      inputRef={ref}
                                      name={name}
                                      options={bankAccountOptions.filter(e => e.data.currencyCode === CURRENCY_CODE.USD)}
                                      value={bankAccountOptions.find(
                                        (c) => +c.value === +value
                                      ) || null}
                                      onChange={(val) => onChange(val.value)}
                                    />
                                  )}
                                /> : type === 'CUSTOMER' ? <Controller
                                  control={control}
                                  name="key"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, name, ref }) => (
                                    <ReactSelect
                                      classNamePrefix="form-control"
                                      inputRef={ref}
                                      name={name}
                                      options={customerOptions}
                                      value={customerOptions.find(
                                        (c) => c.value === value
                                      ) || null}
                                      onChange={(val) => onChange(val.value)}
                                    />
                                  )}
                                /> : type === 'INGREDIENT_LAST_WEIGHT' ? <Controller
                                  control={control}
                                  name="key"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, name, ref }) => (
                                    <ReactSelect
                                      classNamePrefix="form-control"
                                      inputRef={ref}
                                      name={name}
                                      options={ingredientOptions}
                                      value={ingredientOptions.find(
                                        (c) => c.value === value
                                      ) || null}
                                      onChange={(val) => {
                                        onChange(val.value)
                                      }}
                                    />
                                  )}
                                /> : type === 'MORTGAGE_CONTRACT' ? <Controller
                                  control={control}
                                  name="key"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, name, ref }) => (
                                    <ReactSelect
                                      classNamePrefix="form-control"
                                      inputRef={ref}
                                      name={name}
                                      options={mortgageContracts}
                                      value={mortgageContracts.find(
                                        (c) => c.value === value
                                      ) || null}
                                      onChange={(val) => onChange(val?.value)}
                                    />
                                  )}
                                /> : type === 'TAX' ? <Controller
                                  control={control}
                                  name="key"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, name, ref }) => (
                                    <ReactSelect
                                      classNamePrefix="form-control"
                                      inputRef={ref}
                                      name={name}
                                      options={TAX_DETAIL_KEY_OPTIONS}
                                      value={TAX_DETAIL_KEY_OPTIONS.find(
                                        (c) => c.value === value
                                      ) || null}
                                      onChange={(val) => onChange(val?.value)}
                                    />
                                  )}
                                /> : type === 'INVENTORY_MATERIAL' ? <Controller
                                  control={control}
                                  name="key"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, name, ref }) => (
                                    <ReactSelect
                                      classNamePrefix="form-control"
                                      inputRef={ref}
                                      name={name}
                                      options={materialOptions}
                                      value={materialOptions.find(
                                        (c) => c.value === value
                                      ) || null}
                                      onChange={(val) => {
                                        onChange(val.value)
                                      }}
                                    />
                                  )}
                                /> : type === 'PROCESSING_INVENTORY' ? <Controller
                                  control={control}
                                  name="key"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, name, ref }) => (
                                    <ReactSelect
                                      classNamePrefix="form-control"
                                      inputRef={ref}
                                      name={name}
                                      options={processingCustomerOptions}
                                      value={processingCustomerOptions.find(
                                        (c) => buildProcessingInventoryKey(c.value) === value
                                      ) || null}
                                      onChange={(val) => onChange(buildProcessingInventoryKey(val.value))}
                                    />
                                  )}
                                /> : <Controller
                                  control={control}
                                  name="key"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, name, ref }) => (
                                    <Input value={value} onChange={e => onChange(e.target.value)} />
                                  )}
                                />
                          }

                          <ErrorMessage
                            errors={errors}
                            name="key"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="interestRate">
                          Giá trị
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="value"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                placeholder="10"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val?.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="value"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col size="12">
                      <Button color="primary" type="submit">
                        <Icon className="plus"></Icon>
                        <span>Xác nhận</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá khoản vay này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    onDelete(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default SumaryStatementManager;
